(function () {
    console.log(222)
    if (document.querySelector('#popup_customer_login')) {
        const btn = document.querySelector('#popup_customer_login .popup-account__btn-login')
        const loader = document.querySelector('#popup_customer_login .loader_wr')
        const error = document.querySelector("#popup_customer_login .form__error")

        btn.addEventListener('click', () => {
            loader.classList.add('active')

            setTimeout(() => {
                error.classList.remove('hidden')
                loader.classList.remove('active')
            }, 10000);
        })
    }
})();

// show menu
// (function () {
//     const menu = document.querySelector('.popup_navigation')
//     const button = document.querySelector('.header__btn-menu')
//     const popup = document.querySelector('.popup')
//     const close = document.querySelector('.popup-navigation__close')
//     const bg = document.querySelector('.popup__bg ')

//     button.addEventListener('click', () => {
//         menu.classList.add('show', 'visible')
//         popup.classList.add('show', 'active')
//         bg.classList.add('visible', 'animate')
//     })
//     close.addEventListener('click', () => {
//         menu.classList.remove('show', 'visible')
//         popup.classList.remove('show', 'active')
//         bg.classList.remove('visible', 'animate')
//     })
// })();
// show menu

// share button
(function () {
    if (document.getElementById('shareButton')) {
        document.addEventListener('DOMContentLoaded', (event) => {
            const shareButton = document.getElementById('shareButton');
        
            shareButton.addEventListener('click', async () => {
                if (navigator.share) {
                    try {
                        await navigator.share({
                            title: 'Check out this website!',
                            text: 'This is an amazing website you should check out.',
                            url: window.location.href
                        });
                        console.log('Successful share');
                    } catch (error) {
                        console.log('Error sharing:', error);
                    }
                } else {
                    alert('Web Share API is not supported in your browser.');
                }
            });
        });        
    }
})();
// share button
/* KAZKA 23.10.2026: the chat link in the company line opens the chat instead of the contact
   page, when the chat is on the page (the snippet kazka-chat-invite opens it). */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[data-kz-chat-open]');
  var c = document.querySelector('shopify-chat');
  if (a && c && typeof c.show === 'function') { e.preventDefault(); }
});

/* KAZKA 23.10.2026: the catalogue list scrolls in itself (custom.css). Its height is the room
   below the button, measured when it opens; a flyout is fixed beside its row so the scrolling
   list cannot clip it. */
(function () {
  function nav() { return document.querySelector('.kz-catalog .js-vertical-menu'); }
  function bottomLimit() {
    var bottom = window.innerHeight;
    document.querySelectorAll('#PBarNextFrameWrapper, #preview-bar-iframe, #shopify-pc__banner, [data-kz-bottom-cover]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top > window.innerHeight / 2 && r.top < bottom) bottom = r.top;
    });
    return bottom;
  }
  function more() {
    var n = nav(), p = n && n.querySelector(':scope > .menu__panel');
    if (p) n.classList.toggle('kz-more', p.scrollTop + p.clientHeight < p.scrollHeight - 4);
  }
  function measure() {
    var n = nav(); if (!n || window.innerWidth < 1025) return;
    // the room ends where something fixed covers the bottom of the window: the Shopify preview
    // bar, a cookie bar -- not at the window's edge
    var top = Math.max(0, n.getBoundingClientRect().top);
    n.style.setProperty('--kz-menu-room', Math.max(160, bottomLimit() - top - 12) + 'px');
    setTimeout(more, 50);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.kz-catalog .js-menu-vertical-btn-toggle')) { setTimeout(measure, 0); setTimeout(measure, 300); }
  });
  window.addEventListener('resize', measure);
  document.addEventListener('scroll', function (e) { if (e.target && e.target.classList && e.target.classList.contains('menu__panel')) more(); }, true);
  window.addEventListener('scroll', function () { if (document.querySelector('.kz-catalog .js-vertical-menu.menu--open')) measure(); }, { passive: true });
  function placeFly(item) {
    var dd = item.querySelector(':scope > .menu__dropdown'); if (!dd) return;
    var r = item.getBoundingClientRect(), p = item.closest('.menu__panel').getBoundingClientRect();
    dd.classList.add('kz-fly');
    var h = dd.offsetHeight || 0, top = Math.min(r.top, bottomLimit() - h - 8);
    // the theme rewrites the flyout's own style attribute when it opens it, so the place is
    // handed over as variables on the menu, which the theme leaves alone
    var n = item.closest('.js-vertical-menu');
    n.style.setProperty('--kz-fly-top', Math.max(8, top) + 'px');
    n.style.setProperty('--kz-fly-left', p.right + 'px');
  }
  document.addEventListener('mouseover', function (e) {
    if (window.innerWidth < 1025 || !e.target.closest) return;
    var item = e.target.closest('.kz-catalog .js-vertical-menu .menu__level-01 > .menu__item--has-children');
    if (!item) return;
    placeFly(item);
    // the flyout has no height until the theme shows it: place it again once it is open
    setTimeout(function () { placeFly(item); }, 80);
    setTimeout(function () { placeFly(item); }, 250);
    setTimeout(function () { placeFly(item); }, 500);
    setTimeout(function () { placeFly(item); }, 800);
  }, true);
})();

/* KAZKA 23.10.2026: open the chat from the agent line and the company line (the ticker that
   used to do it is switched off); keep the top bar on one line; stick only the search line. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-kz-chat-open]');
    if (!b) return;
    var c = document.querySelector('shopify-chat');
    if (c && typeof c.show === 'function') { e.preventDefault(); c.show(); }
  });

  function fitTape() {
    document.querySelectorAll('.header__tape .container > div').forEach(function (box) {
      var t = box.querySelector('.kz-tape-fit');
      if (!t) {
        t = document.createElement('span'); t.className = 'kz-tape-fit';
        while (box.firstChild && !(box.firstChild.classList && box.firstChild.classList.contains('header__tape-close'))) t.appendChild(box.firstChild);
        box.insertBefore(t, box.firstChild);
      }
      // the full sentence first; where even 10.5 px is not enough (a phone), the promises
      // at the end give way, one whole promise at a time -- never half a word
      if (!t.dataset.full) t.dataset.full = t.textContent.trim();
      var parts = t.dataset.full.split(' · ');
      var room = box.parentElement.clientWidth - 8, size;
      for (var n = parts.length; n >= 1; n--) {
        t.textContent = parts.slice(0, n).join(' · ');
        size = 13; t.style.fontSize = size + 'px';
        while (t.scrollWidth > t.clientWidth && size > 10.5) { size -= 0.5; t.style.fontSize = size + 'px'; }
        if (t.scrollWidth <= t.clientWidth) break;
      }
    });
  }

  function stick() {
    var sec = document.querySelector('.shopify-section-group-header-group[id$="__header"]');
    var line = sec && [].find.call(sec.querySelectorAll('.header__line-top'), function (l) { return l.offsetHeight > 0 || l.getClientRects().length; });
    if (!sec || !line) return;
    var root = document.documentElement, fixed = root.classList.contains('kz-fixed');
    if (!fixed) sec.dataset.kzH = sec.offsetHeight;
    var past = window.scrollY > sec.offsetTop + (+sec.dataset.kzH || sec.offsetHeight);
    if (past && !fixed) { sec.style.height = sec.dataset.kzH + 'px'; root.classList.add('kz-fixed'); }
    else if (!past && fixed && window.scrollY <= sec.offsetTop + (+sec.dataset.kzH) - line.offsetHeight) { root.classList.remove('kz-fixed'); sec.style.height = ''; }
  }
  function all() { fitTape(); stick(); }
  document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all);
  window.addEventListener('resize', all);
  window.addEventListener('scroll', stick, { passive: true });
})();

/* KAZKA 23.10.2026: desk search. The suggestions MERA writes every week (mera.popular_searches)
   were shown on phones only; on the desk they now open on the first click into the empty field.
   The box is built from the same content the theme already prepares (.search-popular-box), so
   there is one source. Both the suggestions and the live results scroll inside themselves. */
(function () {
  var box = null, input = null;
  function bottomEdge() {
    var bottom = window.innerHeight;
    document.querySelectorAll('#PBarNextFrameWrapper, #preview-bar-iframe, #shopify-pc__banner').forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.height > 0 && r.top > window.innerHeight / 2 && r.top < bottom) bottom = r.top;
    });
    return bottom;
  }
  function place() {
    if (!input) return;
    var form = input.closest('.header__search-form') || input;
    var r = form.getBoundingClientRect();
    var room = Math.max(200, bottomEdge() - r.bottom - 16) + 'px';
    document.documentElement.style.setProperty('--kz-search-room', room);
    if (box) { box.style.top = r.bottom + 'px'; box.style.left = r.left + 'px'; box.style.width = r.width + 'px'; }
  }
  function build() {
    if (box) return box;
    var src = document.querySelector('.search-popular-box');
    if (!src) return null;
    box = document.createElement('div'); box.className = 'kz-search-suggest'; box.hidden = true;
    box.innerHTML = src.innerHTML; document.body.appendChild(box);
    box.addEventListener('mousedown', function (e) { e.preventDefault(); });
    return box;
  }
  function show() { if (window.innerWidth < 992 || !input || input.value !== '' || !build()) return; place(); box.hidden = false; }
  function hide() { if (box) box.hidden = true; }
  document.addEventListener('focusin', function (e) {
    var i = e.target;
    if (i.matches && i.matches('.header__line-top .header__search-form input[type="search"]')) { input = i; show(); }
  });
  document.addEventListener('input', function (e) {
    if (e.target === input) { if (input.value === '') show(); else { hide(); place(); } }
  });
  document.addEventListener('focusout', function (e) { if (e.target === input) setTimeout(hide, 150); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  window.addEventListener('scroll', function () { if (box && !box.hidden) place(); }, { passive: true });
  window.addEventListener('resize', place);
})();

/* KAZKA 23.10.2026: one-line author on book cards: drop "(UA)" first, then shrink to 11 px.
   24.10.2026: measured on the whole line, which may carry several authors. */
(function () {
  function mark(a) {
    if (a.dataset.kzUa) return;
    a.dataset.kzUa = '1';
    var t = a.lastChild;
    if (t && t.nodeType === 3 && /\s*\(UA\)\s*$/.test(t.nodeValue)) {
      t.nodeValue = t.nodeValue.replace(/\s*\(UA\)\s*$/, '');
      var s = document.createElement('span'); s.className = 'kz-ua'; s.textContent = ' (UA)'; a.appendChild(s);
    }
  }
  function size(line, px) {
    line.style.fontSize = px ? px + 'px' : '';
    line.querySelectorAll('a').forEach(function (a) { a.style.fontSize = px ? px + 'px' : ''; });
  }
  function fit(line) {
    line.querySelectorAll('a').forEach(mark);
    var ua = line.querySelectorAll('.kz-ua');
    size(line, 0); ua.forEach(function (u) { u.classList.remove('kz-off'); });
    if (!line.clientWidth || line.scrollWidth <= line.clientWidth) return;
    ua.forEach(function (u) { u.classList.add('kz-off'); });
    if (line.scrollWidth <= line.clientWidth) return;
    var a0 = line.querySelector('a') || line, px = parseFloat(getComputedStyle(a0).fontSize);
    while (line.scrollWidth > line.clientWidth && px > 11) { px -= 0.5; size(line, px); }
  }
  function all() { document.querySelectorAll('.product-collection__author').forEach(fit); }
  var t; function soon() { clearTimeout(t); t = setTimeout(all, 120); }
  document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all);
  window.addEventListener('resize', soon);
  new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { soon(); break; } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* KAZKA 24.10.2026: on every product overview (search and collections) the visitor chooses grid or
   list. The search opens as a list, every collection as a grid (operator); the choice is remembered
   on the device, separately for search and collections (localStorage, no cookie banner needed). The
   theme's own switcher exists only on wide screens, so this one replaces it and drives it. */
(function () {
  var cls = document.body.classList;
  var isSearch = cls.contains('template-search');
  if (!isSearch && !cls.contains('template-collection')) return;
  if (!document.querySelector('.collection-product-grid, [data-js-collection-grid-buttons]') && document.readyState !== 'loading') return;
  cls.add('kz-views');
  var KEY = isSearch ? 'kz-search-view' : 'kz-collection-view';
  var DEF = isSearch ? 'list' : 'grid';
  var mode = DEF;
  try { mode = localStorage.getItem(KEY) || DEF; } catch (e) {}
  var gridVal = null;
  var ICON_GRID = '<svg viewBox="0 0 18 18" aria-hidden="true"><rect x="1" y="1" width="7" height="7"/><rect x="10" y="1" width="7" height="7"/><rect x="1" y="10" width="7" height="7"/><rect x="10" y="10" width="7" height="7"/></svg>';
  var ICON_LIST = '<svg viewBox="0 0 18 18" aria-hidden="true"><rect x="1" y="1" width="5" height="5"/><rect x="8" y="2" width="9" height="3"/><rect x="1" y="7" width="5" height="5"/><rect x="8" y="8" width="9" height="3"/><rect x="1" y="13" width="5" height="4"/><rect x="8" y="14" width="9" height="3"/></svg>';
  function themeBtn(v) { return document.querySelector('[data-js-collection-grid-buttons] [data-value="' + v + '"]'); }
  function apply(m, user) {
    mode = m;
    document.body.classList.toggle('kz-list', m === 'list');
    if (window.innerWidth >= 1025 && user !== 'init') { var b = themeBtn(m === 'list' ? 'list' : (gridVal || '4')); if (b) b.click(); }
    document.querySelectorAll('.kz-view__btn').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === m ? 'true' : 'false'); });
    if (user === true) { try { localStorage.setItem(KEY, m); } catch (e) {} }
  }
  function build() {
    var host = document.querySelector('[data-js-collection-grid-buttons]');
    if (!host || host.querySelector('.kz-view')) return;
    /* The theme marks its current choice with data-active-<breakpoint> and keeps it in localStorage
       ('collection-grid'), shared by search and collections -- so the real state is read from the
       grid itself: a card spanning all twelve columns at the current breakpoint is the theme's list
       (our own list class widens the cards too, so their width would prove nothing). */
    var vals = [].slice.call(host.querySelectorAll('[data-value]')).map(function (e) { return e.getAttribute('data-value'); }).filter(function (x) { return x !== 'list'; });
    gridVal = vals.length ? vals[vals.length - 1] : null;
    var w = document.createElement('div'); w.className = 'kz-view'; w.setAttribute('role', 'group');
    w.innerHTML = '<button type="button" class="kz-view__btn" data-view="grid" aria-label="Grid">' + ICON_GRID + '</button>' +
                  '<button type="button" class="kz-view__btn" data-view="list" aria-label="List">' + ICON_LIST + '</button>';
    host.appendChild(w);
    w.addEventListener('click', function (e) { var b = e.target.closest('.kz-view__btn'); if (b) apply(b.dataset.view, true); });
    var grid = document.querySelector('.collection-product-grid'), card = grid && grid.querySelector(':scope > div');
    var bp = window.innerWidth >= 1260 ? 'xl' : 'lg';
    var themeMode = (card && card.classList.contains('col-' + bp + '-12')) ? 'list' : 'grid';
    apply(mode, mode === themeMode ? 'init' : false);
  }
  document.body.classList.toggle('kz-list', mode === 'list');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build); else build();
  window.addEventListener('load', build);
})();

/* KAZKA 24.10.2026: on search and collection pages the heading stands at the top of the results
   column, the filters start beside it right under the header -- as at Readeat. Sorting and the
   view switcher stay on the same line, right. layout/theme.liquid does this while the page is
   parsed; this is the fallback. */
(function () {
  var cl = document.body.classList;
  if (!cl.contains('template-search') && !cl.contains('template-collection')) return;
  function move() {
    var h = document.querySelector('.collection-page-heading h1, main h1.h3');
    var ctrl = document.querySelector('.collection-control');
    if (!h || !ctrl || ctrl.contains(h)) return;
    h.classList.add('kz-search-title');
    ctrl.insertBefore(h, ctrl.firstChild);
    document.body.classList.add('kz-title-in');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move); else move();
})();


/* KAZKA 24.10.2026: the search suggestions scroll inside their own box, but the theme loads a lazy
   image only when the page itself scrolls -- below the sixth result the covers stayed empty. The
   thumbnails are small (about 200 px), so every one in the list is loaded as soon as it arrives. */
(function () {
  function load(img) {
    if (img.dataset.kzEager) return;
    img.dataset.kzEager = '1';
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
    img.addEventListener('load', function () { img.classList.add('loaded', 'entered'); img.style.opacity = '1'; }, { once: true });
  }
  function scan() {
    document.querySelectorAll('.search-ajax__content img.lazyload:not(.loaded)').forEach(load);
  }
  var t; function soon() { clearTimeout(t); t = setTimeout(scan, 60); }
  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      var n = m[i].target;
      if (n.closest && n.closest('.search-ajax')) { soon(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('scroll', function (e) { if (e.target.closest && e.target.closest('.search-ajax')) scan(); }, true);
})();

/* KAZKA 24.10.2026: catalogue panel (snippets/kz-mega-menu.liquid). The "Каталог" button opens one large panel
   under the search line; hovering a main entry switches the right side after a short pause (so passing over
   entries on the way does not flicker), clicking goes to the category. Closes with the button, Escape, a click on
   the dimmed page or on a link. Desktop only -- the phone keeps the theme's menu. */
(function () {
  var mega = document.querySelector('[data-kz-mega]');
  if (!mega) return;
  document.body.appendChild(mega);
  var desk = function () { return window.innerWidth >= 1025; };
  var btn = function () { return document.querySelector('.kz-catalog .js-menu-vertical-btn-toggle'); };
  function place() {
    var line = document.querySelector('.header__line-top');
    var top = line ? Math.max(0, Math.round(line.getBoundingClientRect().bottom)) : 0;
    mega.style.setProperty('--kz-mega-top', top + 'px');
  }
  function open() { place(); mega.hidden = false; var b = btn(); if (b) b.classList.add('menu-vertical-btn--open'); }
  function close() { mega.hidden = true; var b = btn(); if (b) b.classList.remove('menu-vertical-btn--open'); }
  function show(key) {
    mega.querySelectorAll('.kz-mega__top').forEach(function (a) { a.classList.toggle('is-active', a.dataset.kzMegaKey === key); });
    mega.querySelectorAll('[data-kz-mega-pane]').forEach(function (p) { p.hidden = p.dataset.kzMegaPane !== key; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.kz-catalog .js-menu-vertical-btn-toggle');
    if (!b || !desk()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (mega.hidden) open(); else close();
  }, true);
  mega.addEventListener('click', function (e) {
    if (e.target.closest('[data-kz-mega-close]')) close();
    else if (e.target.closest('a[href]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mega.hidden) close(); });
  var timer;
  mega.addEventListener('mouseover', function (e) {
    var a = e.target.closest('.kz-mega__top');
    clearTimeout(timer);
    if (!a || !a.dataset.kzMegaKey || a.classList.contains('is-active')) return;
    timer = setTimeout(function () { show(a.dataset.kzMegaKey); }, 90);
  });
  mega.addEventListener('focusin', function (e) {
    var a = e.target.closest('.kz-mega__top');
    if (a && a.dataset.kzMegaKey) show(a.dataset.kzMegaKey);
  });
  window.addEventListener('scroll', function () { if (!mega.hidden) place(); }, { passive: true });
  window.addEventListener('resize', function () { if (!desk()) close(); else if (!mega.hidden) place(); });
})();

/* KAZKA 24.10.2026: while the catalogue panel is open the mouse wheel never scrolls the page behind it (operator:
   "everything jumps through the air"). The wheel moves the list under the pointer as far as that list goes, and
   nothing beyond -- also over a column that has nothing to scroll and over the dimmed page. */
(function () {
  var mega = document.querySelector('[data-kz-mega]');
  if (!mega) return;
  mega.addEventListener('wheel', function (e) {
    var box = e.target.closest('.kz-mega__side, .kz-mega__body');
    if (!box) { e.preventDefault(); return; }
    var dy = e.deltaY;
    var atTop = box.scrollTop <= 0, atEnd = box.scrollTop + box.clientHeight >= box.scrollHeight - 1;
    if ((dy < 0 && atTop) || (dy > 0 && atEnd)) e.preventDefault();
  }, { passive: false });
})();

/* KAZKA 24.10.2026: the sticky top row of the phone filter panel carries its heading on the left ("Фільтр",
   kazka.filter.title, handed over by layout/theme.liquid as window.kzFilterTitle). */
(function () {
  function title() {
    var head = document.querySelector('.popup-sidebar__head');
    var btn = document.querySelector('[data-js-popup-button="sidebar"]');
    if (!head || !btn || head.querySelector('.kz-filter-title')) return;
    var t = window.kzFilterTitle || '';
    if (!t) return;
    var h = document.createElement('span'); h.className = 'kz-filter-title'; h.textContent = t;
    head.insertBefore(h, head.firstChild);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', title); else title();
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-js-popup-button="sidebar"]')) setTimeout(title, 0); }, true);
})();
